import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Search } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function NotFound() {
  const { t, dir, lang } = useLanguage();
  const nf = t.notFound;
  return (
    <section
      dir={dir}
      lang={lang}
      className="min-h-screen flex items-center justify-center px-5 sm:px-8 py-28 bg-black text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_30%,rgba(212,175,55,0.14),transparent_70%)]" />
      <div className="relative mx-auto max-w-2xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 rounded-full border border-agency-gold/30 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.25em] text-agency-gold"
        >
          <Search size={14} /> {nf.badge}
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.08 }}
          className="mt-6 font-display text-5xl sm:text-6xl md:text-7xl font-black tracking-[-0.03em]"
        >
          {nf.heading}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.16 }}
          className="mt-5 text-white/65 text-base sm:text-lg leading-relaxed"
        >
          {nf.body}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.24 }}
          className="mt-10 flex flex-col sm:flex-row justify-center gap-3"
        >
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-agency-gold text-black font-bold uppercase tracking-[0.2em] text-xs px-7 py-4 hover:bg-white transition-colors"
          >
            <ArrowLeft size={14} className="rtl:rotate-180" /> {nf.backHome}
          </Link>
          <Link
            to="/demos"
            className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-semibold uppercase tracking-[0.2em] text-xs px-7 py-4 hover:border-agency-gold hover:text-agency-gold transition-colors"
          >
            {nf.viewDemos}
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
